import type { AiCostLimitSubjectsPayload } from '@Application/AiCostLimits/Subjects/Actions/aiCostLimitSubjectsFetched';
import type { AiCostLimitLevel } from '@Domain/AiCostLimits/AiCostLimitLevel';
import AiCostLimitSubjectView from '@UI/Store/AiCostLimits/Views/AiCostLimitSubjectView';

/** Immutable View: the structures and facilities a limit can bound for one account. */
class AiCostLimitSubjectsView {
	readonly accountId: number;
	readonly organizations: readonly AiCostLimitSubjectView[];
	readonly facilities: readonly AiCostLimitSubjectView[];

	constructor(accountId: number, payload: AiCostLimitSubjectsPayload) {
		this.accountId = accountId;
		this.organizations = Object.freeze(
			payload.organizations.map((organization) => new AiCostLimitSubjectView(organization)),
		);
		this.facilities = Object.freeze(
			payload.facilities.map((facility) => new AiCostLimitSubjectView(facility)),
		);

		Object.freeze(this);
	}

	findName(level: 'organization' | 'facility', subjectId: number): string | null {
		const candidates = level === 'organization' ? this.organizations : this.facilities;

		return candidates.find((candidate) => candidate.id === subjectId)?.name ?? null;
	}

	/** Whether the caller can bound this subject: the account and users are not listed here. */
	covers(level: AiCostLimitLevel, subjectId: number): boolean {
		if (level === 'organization' || level === 'facility') {
			return this.findName(level, subjectId) !== null;
		}

		return true;
	}
}

export default AiCostLimitSubjectsView;
